import { useCallback, useEffect, useState } from 'react';
import { DocWorkflowMetaData } from '../components/card-view-content/types';
import { useAppSelector } from '../../../common/hooks/useAppSelector';
import { selectUser } from '../../../slices/user/userSlice';
import { NWClient } from '../../../client/NWClient';
import { RootState } from '../../../store';

export const useDocumentsMetaData = (activeTab?: string, category?: string, profile?: number) => {
  const currentUser = useAppSelector(selectUser);
  const uploadingDocumentStatus = useAppSelector((state: RootState) => state.documents.status);
  const [uploadedDocumentsMetaData, setUploadedDocumentsMetaData] = useState<DocWorkflowMetaData[]>(
    []
  );
  const getDocumentsMetaData = useCallback(() => {
    const statuses = ['uploading', 'updating', 'deleting', 'loading'];
    console.log(uploadingDocumentStatus);
    if (
      currentUser.id &&
      statuses.every((el) => uploadingDocumentStatus !== el) &&
      activeTab === 'All'
    ) {
      const payload: Record<string, any> = {
        user: currentUser.id,
      };

      if (category) {
        payload.category = category;
      }

      if (profile) {
        payload.profile = profile;
      }
      NWClient.list('metadata', payload).then((res: any) => {
        if ('workflows' in res) {
          setUploadedDocumentsMetaData(res.workflows);
        }
      });
    }
  }, [currentUser.id, activeTab, uploadingDocumentStatus, category, profile]);

  useEffect(() => {
    getDocumentsMetaData();
  }, [getDocumentsMetaData]);

  return {
    uploadedDocumentsMetaData,
  };
};
